'use strict'

import dataLayer, { type DataLayer } from 'assets/core/js/module/dataLayer'

export const push = (tab: Element): void => {
  // New search events.
  const searchResultsDataRaw = tab.querySelector('.thematic-datalayer-search-results')?.textContent ?? ''
  let searchResultsData: DataLayer | undefined = undefined
  try {
    const parsedData = JSON.parse(searchResultsDataRaw)
    if (parsedData !== null && parsedData !== undefined && parsedData !== false) {
      searchResultsData = parsedData as DataLayer
    }
  } catch {
    // Silently handle parsing errors (invalid JSON or empty content).
  }
  if (searchResultsData) {
    dataLayer.pushInLayer(window.coreGtmId, searchResultsData)
  }
}
